import { render, staticRenderFns } from "./TemplateDashboard.vue?vue&type=template&id=3be390ca"
import script from "./TemplateDashboard.vue?vue&type=script&lang=js"
export * from "./TemplateDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports